export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-7d2cc2f1665e07741271459a7c2286f6.woff2";